export default __webpack_public_path__ + "static/media/PlayH3.991633d7.png";